import { validateMaximum } from 'hb-react/shared/utils/validators/maximum';
import { validateMaximumNumberOfDecimals } from 'hb-react/shared/utils/validators/maximumNumberOfDecimals';
import { validateMinimum } from 'hb-react/shared/utils/validators/minimum';
import { validateNumberFormat } from 'hb-react/shared/utils/validators/numberFormat';
import { validateRequired } from 'hb-react/shared/utils/validators/required';

export const validateNumber = ({
  customValidator,
  maximum,
  maximumErrorLabel,
  maximumNumberOfDecimals,
  minimum,
  minimumErrorLabel,
  required,
  value,
}) => {
  let error;

  if (required) {
    error = validateRequired(value);
  }

  if (!error) {
    error = validateNumberFormat(value);
  }

  if ((minimum || minimum === 0) && !error) {
    error = validateMinimum(value, minimum, minimumErrorLabel);
  }

  if ((maximum || maximum === 0) && !error) {
    error = validateMaximum(value, maximum, maximumErrorLabel);
  }

  if ((maximumNumberOfDecimals || maximumNumberOfDecimals === 0) && !error) {
    error = validateMaximumNumberOfDecimals(value, maximumNumberOfDecimals);
  }

  if (customValidator && !error) {
    error = customValidator(value);
  }

  return error;
};
